import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { client } from './apollo/client';
import { ApolloProvider } from '@apollo/client';
import { Fork } from './Fork';
import { BrowserRouter } from 'react-router-dom';
import { baseHrefService } from '@cobra/services/base-href.service';
import * as sessionStorage from '@cobra/services/shop-session-storage.service';

import './index.scss';

const baseName = baseHrefService.load('availability-check');
const container = document.getElementById('availability-check');

sessionStorage.removeAll();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
    <StrictMode>
        <ApolloProvider client={client}>
            <BrowserRouter basename={baseName}>
                <Fork />
            </BrowserRouter>
        </ApolloProvider>
    </StrictMode>
);
